import "./memberList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import MemberTable from "../membertable/MemberTable";

const MarketList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <MemberTable />
      </div>
    </div>
  );
};

export default MarketList;
